import React from 'react';
import { FDBox, FDStack } from '@facet-wealth/design';

import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import metaOverrideSet from '../../metaOverrideSet';
import AdditionalDetailsSectionImagePicker from './AdditionalDetailsSectionImagePicker/AdditionalDetailsSectionImagePicker';

const AdditionalDetailsSection = ({ resource }) => {
  return (
    <FDBox paddingY={4}>
      <FDStack direction={'column'} spacing={1}>
        <MetaControl resource={resource} attrName={'sectionTitle'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={resource} attrName={'sectionSubtitle'} metaOverrideSet={metaOverrideSet} />
        <AdditionalDetailsSectionImagePicker resource={resource} />
        <MetaControl resource={resource} attrName={'subSections'} metaOverrideSet={metaOverrideSet} />
      </FDStack>
    </FDBox>

  );
};

AdditionalDetailsSection.defaultProps = {};

AdditionalDetailsSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AdditionalDetailsSection;
